<template>
  <Slide right>
    <router-link class="header-nav-link" to="/">
      <span>Home</span>
    </router-link>
    <router-link class="header-nav-link" to="/about/">
      <span>About</span>
    </router-link>
    <router-link class="header-nav-link" to="/services/">
      <span>Services</span>
    </router-link>
    <router-link class="header-nav-link" to="/gallery/">
      <span>Gallery</span>
    </router-link>
    <router-link class="header-nav-link" to="/Contact/">
      <span>Contact</span>
    </router-link>
    <a href="tel:07912877887" class="header-nav-link">
      <span>
        <span class="phone-icon icon-phone"></span>
        <span class="phone-number">07912 877887</span>
      </span>
    </a>
  </Slide>
</template>

<script>
import { Slide } from "vue-burger-menu";

export default {
  name: "mobile-menu",
  components: {
    Slide,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/partials/MobileMenu.vue